import React from 'react';

// Small shared pieces of the site check UI: evidence tags, severity pills,
// panel and button classes, section headings. Colors follow the approved
// preview (docs/superpowers/specs/assets/2026-09-26-site-check-preview.html).

export const FOCUS_RING = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky focus-visible:ring-offset-2 focus-visible:ring-offset-ink';

const BTN = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-[.55] ${FOCUS_RING}`;
export const BTN_PRIMARY = `${BTN} border-transparent bg-cobalt px-4 py-2 text-[13.5px] text-white hover:bg-[#2F62F0] disabled:hover:bg-cobalt`;
export const BTN_GHOST = `${BTN} border-white/20 bg-white/[0.02] px-4 py-2 text-[13.5px] text-cream hover:border-mist disabled:hover:border-white/20`;

export const PANEL = 'rounded-[18px] border border-white/10 bg-deep p-[22px]';
export const PANEL_TITLE = 'm-0 mb-3.5 text-xs font-medium uppercase tracking-[0.1em] text-dim';

const EV_COLOR = {
  observed: 'text-sky',
  inferred: 'text-[#A99BFF]',
  estimated: 'text-amber',
  unknown: 'text-dim',
};

// How a line knows what it says: observed, inferred, estimated or unknown.
export function EvTag({ ev }) {
  const kind = EV_COLOR[ev] ? ev : 'unknown';
  return (
    <span className={`inline-block whitespace-nowrap rounded-full border border-current px-[7px] py-px align-middle font-mono text-[10.5px] font-normal leading-normal tracking-[0.02em] ${EV_COLOR[kind]}`}>
      {kind}
    </span>
  );
}

const SEV_STYLE = {
  critical: 'bg-[rgba(255,107,107,0.14)] text-[#FF6B6B]',
  high: 'bg-[rgba(245,185,66,0.14)] text-amber',
  medium: 'bg-[rgba(94,160,255,0.14)] text-sky',
  low: 'bg-[rgba(154,167,187,0.12)] text-mist',
};

export function SevPill({ severity, children }) {
  const kind = SEV_STYLE[severity] ? severity : 'low';
  return (
    <span className={`inline-block whitespace-nowrap rounded-full px-[9px] py-[3px] text-[11px] font-semibold uppercase leading-normal tracking-[0.06em] ${SEV_STYLE[kind]}`}>
      {children || kind}
    </span>
  );
}

export function SectionHead({ title, note }) {
  return (
    <div className="mb-3.5 mt-10 flex flex-wrap items-baseline justify-between gap-3">
      <h3 className="m-0 font-display text-2xl font-semibold tracking-[-0.015em]">{title}</h3>
      {note ? <p className="m-0 text-[13px] text-dim">{note}</p> : null}
    </div>
  );
}
